import useAsyncData from "../../../../hooks/use-async-data";
import mileageService from "../../mileage.service";
import MileageDictionaryDetails from "./mileage-dictionary-details";
import MileageDictionaryDetailsParams from "./mileage-dictionary-details-params";

const useMileageDictionaryDetails = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<MileageDictionaryDetails | null>(null);

  const load = async (
    loadParams: MileageDictionaryDetailsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const mileageDictionaryDetails =
        await mileageService.getDictionaryDetails(loadParams, signal);

      setData(mileageDictionaryDetails);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMileageDictionaryDetails;
